<template>
  <div class="page-container">
    <div class="page-header">
      <picture class="banner-picture">
        <source media="(max-width: 768px)" srcset="@/assets/img/banner/our_m.jpg" />
        <img class="banner-bg" src="@/assets/img/banner/our.jpg" alt="" />
      </picture>
      <div class="banner-overlay"></div>
      <div class="container">
        <h1>我们的服务</h1>
        <p class="subtitle">全方位的检测解决方案，满足您的多样化需求</p>
      </div>
    </div>
    
    <div class="container content">
      <!-- Services Grid -->
      <div class="section-block">
        <div class="services-grid">
          <div class="service-item" v-for="(service, index) in services" :key="index">
            <div class="icon-box">
              <span class="service-icon">{{ service.icon }}</span>
            </div>
            <h3>{{ service.title }}</h3>
            <p>{{ service.desc }}</p>
            <ul class="feature-list">
              <li v-for="(item, idx) in service.items" :key="idx">{{ item }}</li>
            </ul>
            <button class="consult-btn" @click="dialPhoneNumber">立即咨询</button>
          </div>
        </div>
      </div>
      
      <!-- Service Process -->
      <div class="section-block process-section">
        <h2 class="block-title">服务流程</h2>
        <div class="process-steps">
          <div class="step-item">
            <div class="step-num">01</div>
            <h4>业务咨询</h4>
            <p>确认检测需求与标准</p>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-num">02</div>
            <h4>样品受理</h4>
            <p>填写委托单并送样</p>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-num">03</div>
            <h4>实验检测</h4>
            <p>专业实验室分析测试</p>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-num">04</div>
            <h4>报告出具</h4>
            <p>审核并签发检测报告</p>
          </div>
          <div class="step-line"></div>
          <div class="step-item">
            <div class="step-num">05</div>
            <h4>售后服务</h4>
            <p>报告解读与技术支持</p>
          </div>
        </div>
      </div>
      
      <!-- FAQ -->
      <div class="section-block faq-section">
        <h2 class="block-title">常见问题</h2>
        <div class="faq-list">
          <div class="faq-item" v-for="(faq, i) in faqs" :key="i">
            <div class="faq-question">Q: {{ faq.q }}</div>
            <div class="faq-answer">A: {{ faq.a }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    const services = [
      {
        icon: '🌿',
        title: '环境检测',
        desc: '提供全方位的环境监测服务，助力企业合规排放。',
        items: ['水质检测 (地表水/地下水/废水)', '空气废气检测', '土壤与沉积物检测', '噪声与振动检测']
      },
      {
        icon: '🍎',
        title: '食品农产品',
        desc: '保障食品安全，提供从农田到餐桌的检测服务。',
        items: ['农药/兽药残留', '重金属及微量元素', '微生物指标', '食品添加剂']
      },
      {
        icon: '🧴',
        title: '日化用品',
        desc: '为日化用品提供成分与安全性指标检测及合规支持。',
        items: ['化妆品理化指标', '微生物指标检测', '禁限用物质筛查', '标签与法规合规评估']
      },
      {
        icon: '🏗️',
        title: '建材与工程',
        desc: '确保建筑材料质量，保障工程建设安全。',
        items: ['水泥/混凝土/钢材', '室内空气质量(甲醛/苯)', '建筑节能检测', '主体结构检测']
      },
      {
        icon: '🦠',
        title: '公共卫生',
        desc: '关注公共场所卫生安全，预防疾病传播。',
        items: ['公共场所卫生检测', '集中空调通风系统', '生活饮用水', '消毒效果评价']
      },
      {
        icon: '🔬',
        title: '技术咨询',
        desc: '提供专业的实验室管理及认证咨询服务。',
        items: ['CMA/CNAS认证咨询', '实验室规划设计', '标准制修订', '人员培训']
      }
    ]
    
    const faqs = [
      {
        q: '检测周期一般是多久？',
        a: '常规项目检测周期为5-7个工作日，加急服务可缩短至2-3个工作日（需视具体项目而定）。'
      },
      {
        q: '如何送样？',
        a: '您可以直接将样品邮寄至我司实验室，或联系客服预约上门采样服务。'
      },
      {
        q: '检测报告具有法律效力吗？',
        a: '是的，我司出具的带CMA章的检测报告具有法律效力，可用于司法鉴定、行政处罚、社会仲裁等。'
      }
    ]
    
    const dialPhoneNumber = () => {
      window.location.href = 'tel:4009991636';
    }
    
    return {
      services,
      faqs,
      dialPhoneNumber
    }
  }
}
</script>

<style scoped>
.page-header {
  padding: 0;
  margin-bottom: 60px;
  color: #fff;
  text-align: center;
  position: relative;
  overflow: hidden;
  aspect-ratio: 4 / 1;
  display: flex;
  align-items: center;
}

.banner-picture {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: block;
}

.banner-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: none;
}

.banner-overlay {
  position: absolute;
  inset: 0;
  opacity: 0.08;
  background:
    radial-gradient(650px 360px at 15% 25%, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0) 62%),
    radial-gradient(620px 360px at 85% 45%, rgba(255, 214, 102, 0.04) 0%, rgba(255, 214, 102, 0) 64%),
    linear-gradient(135deg, rgba(125, 74, 199, 0.40) 0%, rgba(74, 20, 140, 0.34) 100%);
  z-index: 1;
}

.banner-overlay::before {
  content: '';
  position: absolute;
  inset: -25%;
  background:
    radial-gradient(closest-side at 18% 30%, rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0)),
    radial-gradient(closest-side at 82% 42%, rgba(255, 189, 92, 0.18), rgba(255, 189, 92, 0)),
    radial-gradient(closest-side at 55% 90%, rgba(160, 132, 255, 0.18), rgba(160, 132, 255, 0));
  filter: blur(22px);
  opacity: 0.9;
  animation: pageBannerBlobs 18s ease-in-out infinite alternate;
}

.banner-overlay::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 10px 10px, rgba(255, 255, 255, 0.14) 2px, rgba(255, 255, 255, 0) 3px),
    radial-gradient(circle at 48px 60px, rgba(255, 255, 255, 0.10) 1px, rgba(255, 255, 255, 0) 2px);
  background-size: 70px 70px, 140px 140px;
  opacity: 0.18;
  animation: pageBannerParticles 26s linear infinite;
  pointer-events: none;
}

.page-header .container {
  display: none;
}

.page-header h1 {
  margin: 0 0 15px 0;
  font-size: 2.5rem;
  font-weight: 700;
  animation: pageFadeUp 700ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.subtitle {
  font-size: 1.2rem;
  opacity: 0.9;
  margin: 0;
  letter-spacing: 1px;
  animation: pageFadeUp 800ms 120ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

@media (max-width: 768px) {
  .page-header {
    aspect-ratio: 4 / 5;
  }
}

@keyframes pageFadeUp {
  from { opacity: 0; transform: translate3d(0, 10px, 0); }
  to { opacity: 1; transform: translate3d(0, 0, 0); }
}

@keyframes pageBannerZoom {
  from { transform: scale(1.06); }
  to { transform: scale(1.12); }
}

@keyframes pageBannerBlobs {
  0% { transform: translate3d(-1%, -1%, 0) scale(1); }
  50% { transform: translate3d(2%, 2%, 0) scale(1.03); }
  100% { transform: translate3d(-2%, 3%, 0) scale(1.02); }
}

@keyframes pageBannerParticles {
  from { background-position: 0 0, 0 0; }
  to { background-position: 0 -420px, 0 -840px; }
}

@media (prefers-reduced-motion: reduce) {
  .banner-bg,
  .banner-overlay::before,
  .banner-overlay::after,
  .page-header h1,
  .subtitle {
    animation: none !important;
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.content {
  padding-bottom: 80px;
}

.section-block {
  margin-bottom: 80px;
}

.block-title {
  font-size: 1.8rem;
  color: #333;
  margin-bottom: 50px;
  text-align: center;
  position: relative;
  padding-bottom: 15px;
}

.block-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #7D4AC7;
}

/* Services Grid */
.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 30px;
}

.service-item {
  background: #fff;
  border: 1px solid #f0f0f0;
  padding: 40px 30px;
  border-radius: 12px;
  transition: all 0.3s;
  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
}

.service-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(125, 74, 199, 0.1);
  border-color: #e0d4f5;
}

.icon-box {
  width: 70px;
  height: 70px;
  background-color: #f8f4fc;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
  transition: all 0.3s;
}

.service-item:hover .icon-box {
  background-color: #7D4AC7;
  color: #fff;
}

.service-icon {
  font-size: 32px;
}

.service-item h3 {
  font-size: 1.4rem;
  margin-bottom: 15px;
  color: #333;
}

.service-item p {
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
  min-height: 48px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0 0 25px 0;
  color: #555;
  flex: 1;
}

.feature-list li {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.feature-list li::before {
  content: "✓";
  color: #7D4AC7;
  margin-right: 10px;
  font-weight: bold;
}

.consult-btn {
  background-color: transparent;
  border: 1px solid #7D4AC7;
  color: #7D4AC7;
  padding: 10px 0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 600;
  width: 100%;
}

.service-item:hover .consult-btn {
  background-color: #7D4AC7;
  color: #fff;
}

/* Process Section */
.process-steps {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}

.step-item {
  text-align: center;
  flex: 1;
  position: relative;
  z-index: 2;
}

.step-num {
  width: 60px;
  height: 60px;
  background-color: #fff;
  border: 2px solid #7D4AC7;
  color: #7D4AC7;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  margin: 0 auto 20px;
  transition: all 0.3s;
}

.step-item:hover .step-num {
  background-color: #7D4AC7;
  color: #fff;
  transform: scale(1.1);
}

.step-item h4 {
  margin-bottom: 10px;
  color: #333;
}

.step-item p {
  color: #666;
  font-size: 0.9rem;
}

.step-line {
  flex: 1;
  height: 2px;
  background-color: #e0d4f5;
  margin-top: 30px;
}

/* FAQ Section */
.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  background-color: #fff;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  border: 1px solid #f0f0f0;
}

.faq-question {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}

.faq-answer {
  color: #666;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .process-steps {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  
  .step-line {
    display: none;
  }
  
  .step-item {
    width: 100%;
  }
}
</style>
